"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparisonComponent = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var React = require("react");
var utils_1 = require("../../../utils");
var StatusComponent_1 = require("../status/StatusComponent");
var ComparisonTypeDropdown_1 = require("./ComparisonTypeDropdown");
var ConstantComparisonValueInput_1 = require("./ConstantComparisonValueInput");
var HistoricalComparisonComponent_1 = require("./HistoricalComparisonComponent");
var ComparisonComponent = function (props) {
    var defaultComparisonType = props.selectedComparison !== null && (0, metrics_engine_1.isStaticComparison)(props.selectedComparison)
        ? ComparisonTypeDropdown_1.ComparisonType.CONSTANT
        : ComparisonTypeDropdown_1.ComparisonType.HISTORICAL;
    var _a = React.useState(defaultComparisonType), selectedComparisonType = _a[0], setSelectedComparisonType = _a[1];
    // This useEffect is written to catch the case when the ComparisonComponent re-renders with a
    // different props.selectedComparison, which may happen when the user resizes the window.
    // When the prop changes, we DON'T want to use the previous state value, we want to reset
    // the state value.
    React.useEffect(function () {
        var _a;
        var selectedComparisonTypeString = (_a = props.selectedComparison) === null || _a === void 0 ? void 0 : _a.type;
        if (selectedComparisonTypeString === 'STATIC_COMPARISON') {
            setSelectedComparisonType(ComparisonTypeDropdown_1.ComparisonType.CONSTANT);
        }
        else if (selectedComparisonTypeString === 'HISTORICAL_COMPARISON' ||
            selectedComparisonTypeString === 'MARK_BASED_COMPARISON') {
            setSelectedComparisonType(ComparisonTypeDropdown_1.ComparisonType.HISTORICAL);
        }
    }, [props.selectedComparison]);
    var onComparisonTypeChange = function (type) {
        setSelectedComparisonType(type);
        switch (type) {
            case ComparisonTypeDropdown_1.ComparisonType.CONSTANT:
                props.onComparisonChange(null);
                break;
            case ComparisonTypeDropdown_1.ComparisonType.HISTORICAL:
                props.onComparisonChange((0, metrics_engine_1.defaultComparisonForGranularity)(props.dateGranularity));
                props.onStatusChange({ above: null, equal: null, below: null });
                break;
            default:
                (0, utils_1.exhaustivelyMatch)(type);
        }
    };
    var showComparisonDropdown = props.isReferenceLineEnabled;
    var showHistoricalComparison = props.isReferenceLineEnabled &&
        props.isHistoricalComparisonsEnabled &&
        props.canAuthorHistoricalComparison &&
        selectedComparisonType === ComparisonTypeDropdown_1.ComparisonType.HISTORICAL;
    var showConstantComparison = props.isReferenceLineEnabled && selectedComparisonType === ComparisonTypeDropdown_1.ComparisonType.CONSTANT;
    return (React.createElement(React.Fragment, null,
        showComparisonDropdown && (React.createElement(ComparisonTypeDropdown_1.ComparisonTypeDropdownComponent, { testId: 'comparison-type-dropdown', canAuthorHistoricalComparison: props.canAuthorHistoricalComparison, selectedComparisonType: selectedComparisonType, onComparisonChange: onComparisonTypeChange, disabled: props.disabled, dropdownRef: props.dropdownRef })),
        showHistoricalComparison && (React.createElement(HistoricalComparisonComponent_1.HistoricalComparisonComponent, { granularity: props.dateGranularity, validationCounter: props.validationCounter, onSelectedComparisonChange: props.onComparisonChange, selectedComparison: props.selectedComparison, disabled: props.disabled })),
        showConstantComparison && (React.createElement(React.Fragment, null,
            React.createElement(ConstantComparisonValueInput_1.ConstantComparisonValueInput, { formatString: props.formatString, validationCounter: props.validationCounter, onSelectedComparisonChange: props.onComparisonChange, selectedComparison: props.selectedComparison, disabled: props.disabled }),
            React.createElement(StatusComponent_1.StatusComponent, { onStatusChange: props.onStatusChange, status: props.status, disabled: props.disabled })))));
};
exports.ComparisonComponent = ComparisonComponent;
//# sourceMappingURL=ComparisonComponent.js.map